// extracted by mini-css-extract-plugin
export var childrenContainer = "_a3-0";